<template>
  <div class="content">
    <div class="c_position">
      <span class="el-icon-location-outline"></span>
      <label>你现在的位置：</label>
      <label><span @click="routerNav()">首页></span>公司介绍><span>{{pos}}</span></label>
    </div>
    <div class="profile">
      <div class="p_left">
        <div style="cursor:auto">公司介绍</div>
        <div v-for="(item,index) in list" :key="index"  @click="ptext(index)" :class="statuNum == 0 && selfnum==index?'change':'normal'">
          <label>{{item.label}}</label>
        </div>
      </div>
      <div class="p_right">
        <div class="p_type">{{type}}</div>
        <!-- <div class="p_text" v-html="listtext"> -->
          <div class="p_content">
            <img v-if="type == '公司简介'" style="width:100%;height: 75%;transform: scale(0.9);" :src="listtext" alt="" >
            <img v-if="type == '发展历程'" :src="listtext" alt="" >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      statuNum: 0,
      selfnum: 0,
      type: "公司简介",
      pos:'公司简介',
      poslist: [
        "公司简介",
        "发展历程",
      ],
      firsttext: 0,
      listtext:'',
      list:[]
    };
  },
  methods: {
    routerNav(){
      this.$router.push({ path: "/home" });
    },
    ptext(num) {
      console.log(num,'b');
      if(this.list[num].articalList[0]){
        this.listtext = this.list[num].articalList[0].body;
      }else{
        this.listtext = '';
      }
      // console.log(this.listtext)
      this.selfnum = num;

      this.type = this.list[num].label;
      this.pos = this.list[num].label
    },
  },
  mounted(){
    window['ptext'] = (num) => {
        this.ptext(num)
    }
    this.list = [
      {
        label:"公司简介",
        articalList:[
          {body:require('@/assets/jianjie.png')}
        ]
      },
      {
        label:"发展历程",
        articalList:[
          {body:require('@/assets/fazhan.png')}
        ]
      },
    ]
      // console.log(id)
      if (this.list !== []) {
        this.ptext(this.$route.query.num)
      }
  }
};
</script>

<style>
.c_position{
  margin:0 20%;
}
</style>
<style lang='less' scoped>
.content{
  height: auto;
}
.c_position {
  margin-left: 50%;
  transform: translate(-200%);
}
.profile {
  width: 1173px;
  min-height: 824px;
  // margin-left: 353px;
  margin-left: 50%;
  transform: translate(-50%);
  // margin:0 20%;
  display: flex;
  flex-direction: row;
  margin-top: 7px;
  .p_left {
    width: 258px;
    height: 730px;
    border: 1px solid #f6f6f6;
    display: flex;
    flex-direction: column;
    background-color: #fdfdfd;
    div {
      width: 258px;
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      label {
        margin-left: 24px;
        margin-top: 20px;
      }
      label:hover {
        cursor: pointer;
      }
    }
    div:hover {
      cursor: pointer;
      background-color: rgba(241, 244, 247, 1);
      color: rgba(19, 71, 121, 1);
    }
    div:nth-child(1) {
      color: white;
      text-align: center;
      font-size: 18px;
      font-weight: 1000;
      background-color: #31689b;
    }
    div:nth-child(1):hover {
      cursor: none;
      background-color: none;
    }
  }
  .p_right {
    min-height: 824px;
    width: 915px;
    .p_content {
      width: 100%;
      // height: 600px;
      // overflow-y: auto;
    }
    .p_content::-webkit-scrollbar {
      display: none;
    }
    .p_type {
      margin-left: 28px;
      height: 60px;
      border-bottom: 1px solid rgba(230, 230, 230, 1);
      color: rgba(49, 104, 155, 1);
      font-size: 18px;
      line-height: 65px;
      font-weight: 1000;
      padding-left: 20px;
    }
    .p_text {
      margin-top: 19px;
      min-height: 744px;
      width: 872px;
      overflow: auto;
      margin-left: 48px;
      color: rgba(16, 16, 16, 1);
      font-size: 16px;
      line-height: 28px;
      font-family: SourceHanSansSC-bold;
      span:hover {
        color: #101010;
        cursor:auto;
        text-decoration:none;
      }
      .c_date {
        // margin-left:10px;
        margin-left: 10px;
        float: right;
        margin-right: 30px;
      }
    }
  }
}
.xls{
  color: rgba(0, 54, 137, 0.83);
font-size: 16px;
}
.xls:hover{
  text-decoration: underline;
  cursor: pointer;
}
</style>
<style lang="less">
    .change {
      background-color: rgba(241, 244, 247, 1);
      color: rgba(19, 71, 121, 1);
    }
    .normal {
      background-color: #fdfdfd;
      color: #000000;
    }
</style>